import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AppContext } from './AppContext';

const ProtectedRoute = ({ children, requiredStep, type = 'default' }) => {
  const { currentStep, statusStep } = useContext(AppContext);

  // Ensure step value is not undefined or incorrect
  const stepToCheck = type === 'status' ? statusStep : currentStep;

  if (stepToCheck === undefined || stepToCheck < requiredStep) {
    return <Navigate to={type === 'status' ? "/checkApplicationStatus" : "/"} replace />;
  }

  return children;
};

export default ProtectedRoute;
